export default __webpack_public_path__ + "static/media/find_ideal_bg.b6008452.png";